<template
  src="./index.html"
  lang="html"></template>
<style
  src="../../stylus/main.css"
  lang="css">
</style>

<script>
  export default {
    props: {
      isMessage: {
        type: Boolean,
        default: true
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      hasTitle: {
        type: Boolean,
        default: true
      },
      isItem: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        default: ''
      },
      image: {
        type: String,
        default: ''
      }
    },
  };
</script>
